// extracted by mini-css-extract-plugin
module.exports = {"package":"Package_package__Kn132","package--editorial":"Package_package--editorial__eXJAs","web":"Package_web__qlWAh"};